const KEY = "dl_recent_orders";
const MAX = 20;

export const readRecentOrders = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]").filter((o) => o?.id); } catch { return []; }
};

export const rememberOrder = (order) => {
  if (!order?.id) return;
  const rest = readRecentOrders().filter((o) => o.id !== order.id);
  const entry = { id: order.id, token: order.access_token || null, order_number: order.order_number, total: order.total, currency: order.currency, created_at: order.created_at };
  localStorage.setItem(KEY, JSON.stringify([entry, ...rest].slice(0, MAX)));
};

export const rememberOrderToken = (id, token) => {
  if (!id || !token) return;
  const list = readRecentOrders();
  if (list.some((o) => o.id === id)) return;
  localStorage.setItem(KEY, JSON.stringify([{ id, token }, ...list].slice(0, MAX)));
};
